import React from 'react'
import { Outlet, NavLink, useLocation } from 'react-router-dom'
import '../../styles/pages.css'

const tabs = [
  { path: '/warehouse/receiving', label: 'Receiving' },
  { path: '/warehouse/testing', label: 'Testing' },
  { path: '/warehouse/repairs', label: 'Repairs' },
  { path: '/warehouse/issue-trades', label: 'Issue Trades' },
  { path: '/warehouse/photography', label: 'Photography' },
  { path: '/warehouse/putaway', label: 'Putaway' },
  { path: '/warehouse/shipping', label: 'Order Shipping' },
  { path: '/warehouse/manual-listing', label: 'Create Product' }
]

function WarehousePage() {
  const location = useLocation()
  const isHome = location.pathname === '/warehouse'

  // On home page, don't show the page header/tabs - WarehouseHome handles its own layout
  if (isHome) {
    return <Outlet />
  }

  return (
    <div className="page">
      <div className="pageHead">
        <h1>Warehouse</h1>
        <p>Physical warehouse operations and workflows</p>
      </div>

      <div className="pageTabs" style={{ overflowX: 'auto' }}>
        {tabs.map(tab => (
          <NavLink
            key={tab.path}
            to={tab.path}
            className={location.pathname === tab.path ? 'active' : ''}
            style={{ whiteSpace: 'nowrap' }}
          >
            {tab.label}
          </NavLink>
        ))}
      </div>

      <Outlet />
    </div>
  )
}

export default WarehousePage
